import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import * as moment from 'moment';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { InformacionUsuario } from 'app/entities/agenda';
import { AgendaService } from 'app/services/agenda-personal/agenda.service';
import { MediaMatcher } from '@angular/cdk/layout';
import { MatSidenav } from '@angular/material';

@Component({
  selector: 'app-ver-agenda',
  templateUrl: './ver-agenda.component.html',
  styleUrls: ['./ver-agenda.component.scss']
})
export class VerAgendaComponent implements OnInit {

  public usuario: InformacionUsuario;

  public datos:Array<any> = [
    {id: 1, text: 'eventos'},
    {id: 2, text: 'eventos'},
    {id: 3, text: 'eventos'},
    {id: 4, text: 'eventos'},
  ];

  constructor(private _agenda: AgendaService)
  {
    this.usuario = {
        id_usuario: JSON.parse(localStorage.getItem('usuario'))['id_usuario'],
        nombre: JSON.parse(localStorage.getItem('usuario'))['nombre'],
        apellido: JSON.parse(localStorage.getItem('usuario'))['apellido'],
        documento: JSON.parse(localStorage.getItem('usuario'))['documento'],
        cargo:JSON.parse(localStorage.getItem('usuario'))['cargo'],
        correo:JSON.parse(localStorage.getItem('usuario'))['correo']
    }
  }

  ngOnInit() {
  }

}
